import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import { ConditionalRender, MainContainer } from '../../Container/index.js';
import LeftBar from './LeftBar/index.js';
import RightBar from './RightBar/index.js';
import { Disclaimer } from './Disclaimer/index.js';
import { GridContainer } from '../../CSS/index.js';
export const SecondaryFooter = memo(({ navCSSClass, universityName, isDisclaimerVisible }) => (_jsx("footer", { css: theme => css({
        padding: '40px 0 50px',
        borderTop: '1px solid #eaf0f1',
        background: theme.primaryBackgroundColor
    }), children: _jsx(MainContainer, { children: _jsxs(GridContainer, { style: {
                alignItems: 'start',
                justifyContent: 'space-between',
                gridTemplateAreas: "'leftSide rightSide' 'disclaimers disclaimers'",
                '@media (min-width: 768px)': {
                    gridTemplateAreas: "'leftSide rightSide' '. disclaimers'"
                }
            }, children: [_jsx(LeftBar, {}), _jsx(RightBar, { navCSSClass: navCSSClass }), _jsx(ConditionalRender, { isContentVisible: !!isDisclaimerVisible, children: _jsx(Disclaimer, { universityName: universityName }) })] }) }) })));
export default SecondaryFooter;
//# sourceMappingURL=index.js.map